/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import CaptionLogo from './CaptionLogo';
import AdminLogo from './AdminLogo';
import IconLogo from './IconLogo';
import TextLogo from './TextLogo';
import FullLogo from './FullLogo';

export interface LogoProps {
  logoType:
    | 'caption-logo'
    | 'full-logo'
    | 'icon-logo'
    | 'text-logo'
    | 'admin-logo';
  styles?: any;
}

const Logo: React.FC<React.PropsWithChildren<LogoProps>> = (props) => {
  const { logoType, styles } = props;
  let selectedLogo;
  switch (logoType) {
    case 'full-logo':
      selectedLogo = <FullLogo aria-label={`Teto-${logoType}`} {...styles} />;
      break;
    case 'icon-logo':
      selectedLogo = <IconLogo aria-label={`Teto-${logoType}`} {...styles} />;
      break;
    case 'text-logo':
      selectedLogo = <TextLogo aria-label={`Teto-${logoType}`} {...styles} />;
      break;
    case 'admin-logo':
      selectedLogo = <AdminLogo aria-label={`Teto-${logoType}`} {...styles} />;
      break;
    default:
      selectedLogo = (
        <CaptionLogo aria-label={`Teto-${logoType}`} {...styles} />
      );
      break;
  }
  return selectedLogo;
};

export default Logo;
